module.exports = __webpack_public_path__ + "fonts/KFOkCnqEu92Fr1MmgVxFIzIFKw.93fb0640.woff2";